import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useImproveCycleStore } from '../store/improveCycleStore'
import PestanasBloqueadas from '../components/improve-cycle/PestanasBloqueadas'
import BarraProgreso from '../components/improve-cycle/BarraProgreso'
import PlanificarForm from '../components/improve-cycle/PlanificarForm'
import HacerForm from '../components/improve-cycle/HacerForm'
import VerificarForm from '../components/improve-cycle/VerificarForm'
import ActuarForm from '../components/improve-cycle/ActuarForm'
import { ArrowLeft, AlertCircle } from 'lucide-react'

const CicloPDCAPage = () => {
  const { cicloId } = useParams()
  const navigate = useNavigate()
  const { cicloActual, loading, error, fetchCiclo, fetchEstadoPestanas } = useImproveCycleStore()
  const [tabActiva, setTabActiva] = useState('planificar')

  useEffect(() => {
    if (cicloId) {
      loadCiclo()
    }
  }, [cicloId])

  const loadCiclo = async () => {
    try {
      const ciclo = await fetchCiclo(parseInt(cicloId))
      setTabActiva(ciclo.fase_actual === 'completado' ? 'actuar' : ciclo.fase_actual)
      await fetchEstadoPestanas(parseInt(cicloId))
    } catch (err) {
      console.error('Error loading ciclo:', err)
    }
  }

  const handleTabClick = (tab) => {
    setTabActiva(tab)
  }

  if (loading && !cicloActual) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto"></div>
          <p className="mt-4 text-gray-600">Cargando ciclo...</p>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="max-w-4xl mx-auto p-6">
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 flex items-start gap-3">
          <AlertCircle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
          <div>
            <h3 className="font-semibold text-red-800">Error</h3>
            <p className="text-red-700 text-sm">{error}</p>
          </div>
        </div>
      </div>
    )
  }

  if (!cicloActual) {
    return (
      <div className="max-w-4xl mx-auto p-6">
        <p className="text-gray-600">No se encontró el ciclo</p>
      </div>
    )
  }

  return (
    <div className="max-w-7xl mx-auto p-6">
      {/* Header */}
      <div className="mb-6">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-gray-600 hover:text-gray-800 mb-4"
        >
          <ArrowLeft className="w-5 h-5" />
          Volver
        </button>
        
        <div className="bg-white rounded-lg shadow p-6">
          <h1 className="text-2xl font-bold text-gray-800 mb-2">
            {cicloActual.nombre}
          </h1>
          <p className="text-gray-600">
            Ciclo {cicloActual.numero_ciclo} - {cicloActual.resultado === 'en_curso' ? 'En curso' : cicloActual.resultado}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
        {/* Sidebar - Progress */}
        <div className="lg:col-span-1">
          <BarraProgreso 
            ciclo={cicloActual} 
            estadoPestanas={cicloActual.estado_pestanas} 
          />
        </div>

        {/* Main content */}
        <div className="lg:col-span-3">
          {/* Pestañas Bloqueadas */}
          <div className="bg-white rounded-lg shadow p-6 mb-6">
            <PestanasBloqueadas
              estadoPestanas={cicloActual.estado_pestanas}
              faseActual={cicloActual.fase_actual}
              onTabClick={handleTabClick}
            />
          </div>

          {/* Content area */}
          <div className="bg-white rounded-lg shadow p-6">
            {tabActiva === 'planificar' && (
              <div>
                <h2 className="text-xl font-bold mb-4">Fase Planificar</h2>
                <PlanificarForm ciclo={cicloActual} />
              </div>
            )}

            {tabActiva === 'hacer' && (
              <div>
                <h2 className="text-xl font-bold mb-4">Fase Hacer</h2>
                <HacerForm ciclo={cicloActual} />
              </div>
            )}

            {tabActiva === 'verificar' && (
              <div>
                <h2 className="text-xl font-bold mb-4">Fase Verificar</h2>
                <VerificarForm ciclo={cicloActual} />
              </div>
            )}

            {tabActiva === 'actuar' && (
              <div>
                <h2 className="text-xl font-bold mb-4">Fase Actuar</h2>
                <ActuarForm ciclo={cicloActual} />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default CicloPDCAPage
